var lazyLoadInstance = (function() {
    return new LazyLoad({
        restore_on_error: true,
        callback_loading: function() {

        }
    });
})();